import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  ICreateAddOnCheckoutSessionRequest,
  ICreateCheckoutSessionRequest,
  IUpdateSubscriptionRequest,
} from '@/types';

import {
  createAddOnCheckoutSession,
  createCheckoutSession,
  managePaymentMethod,
  updateSubscription,
} from '../requests/stripe.requests';

export const useCreateCheckoutSession = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: ICreateCheckoutSessionRequest) => {
      const res = await createCheckoutSession(payload);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['user'],
      });
      queryClient.invalidateQueries({
        queryKey: ['active-subscription'],
      });
      queryClient.invalidateQueries({
        queryKey: ['feature-usage-status'],
      });
    },
  });
};

export const useUpdateSubscription = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: IUpdateSubscriptionRequest) => {
      const res = await updateSubscription(payload);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['user'],
      });
      queryClient.invalidateQueries({
        queryKey: ['active-subscription'],
      });
      queryClient.invalidateQueries({
        queryKey: ['feature-usage-status'],
      });
    },
  });
};

export const useManagePaymentMethod = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: IUpdateSubscriptionRequest) => {
      const res = await managePaymentMethod(payload);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['user'],
      });
      queryClient.invalidateQueries({
        queryKey: ['active-subscription'],
      });
      queryClient.invalidateQueries({
        queryKey: ['feature-usage-status'],
      });
    },
  });
};

export const useCreateAddOnCheckoutSession = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: ICreateAddOnCheckoutSessionRequest) => {
      const res = await createAddOnCheckoutSession(payload);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['user'],
      });
      // Also invalidate active subscription since addons are part of it
      queryClient.invalidateQueries({
        queryKey: ['active-subscription'],
      });
      queryClient.invalidateQueries({
        queryKey: ['feature-usage-status'],
      });
    },
  });
};
